export default function () {
  return {
    S3galeria: null,
    S3carpetas: null, 
  };
}
